<div class="bg-light rounded-3 shadow sticky-top"  style="z-index: 0;">
  <nav class="nav flex-column justify-content-between px-2 menu-cust">
      <li class="nav-item"><a class="nav-link" [routerLink]="['/knowledge-products/national-repository']" [routerLinkActive]="['active']">NRLM National Repository</a></li>
      <li class="nav-item"><a class="nav-link" [routerLink]="['/knowledge-products/nrlm-documents']" [routerLinkActive]="['active']">NRLM Documents</a></li>
      <li class="nav-item "><a class="nav-link" [routerLink]="['/knowledge-products/newsletters']" [routerLinkActive]="['active']">Newsletters</a></li>
      <li class="nav-item"><a class="nav-link" [routerLink]="['/our-impact/success-stories']" [routerLinkActive]="['active']">Success Stories</a></li>
  </nav>
</div>
